import { Breadcrumbs, Typography, Link, styled } from "@mui/material";
import { useObrasInformacoesGeraisViewModel } from "../../viewModels/obras_informacoes_gerais_view_model";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { isValidId } from "../../../../../common/utils/utils";
import { EstOrgModal } from "./components/est_org_modal";
import { useMemo } from "react";
import { GenerateObraEstruturaOrganizacionalColumns } from "./columns/obra_estrutura_organizacional";
import { GenerateAtividadeObraColumns } from "./columns/atividade_obra";
import { AtividadeObraModal } from "./components/atividade_obra_modal";
import { GenerateEspecificidadeObraColumns } from "./columns/especificidade_obra";
import { EspecificidadeObraModal } from "./components/especificidade_obra_modal";
import { GenerateIndicadorObraColumns } from "./columns/indicador_obra";
import { IndicadorObraModal } from "./components/indicador_obra_modal";
import { GenerateObraArquivoColumns } from "./columns/obra_arquivo";
import { ObraArquivoModal } from "./components/obra_arquivo_modal";
import { GenerateObraInformacoesColumns } from "./columns/obra_informacoes";
import { ObraInformacoesModal } from "./components/obra_informacoes_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { ObrasReportModals } from "../../components/obras_report_modals";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { Link as LinkTo } from 'react-router';
import { FolderOpen, Launch } from "@mui/icons-material";
import { ActionBanner } from "../../../../../common/components/ActionBanner";
import { EstOrgListaModal } from "./components/est_org_lista_modal";
import { AtividadeObraListaModal } from "./components/atividade_obra_lista_modal";
import { EspecificidadeObraListaModal } from "./components/especificidade_obra_lista_modal";
import { IndicadorObraListaModal } from "./components/indicador_obra_lista_modal";
import { ObraInformacoesListaModal } from "./components/obra_informacoes_lista_modal";
import { ObraArquivoListaModal } from "./components/obra_arquivo_lista_modal";

import AlertError from "../../../../../common/components/alert_error";
import FormContainer from "../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import BottomBar from "../../../../../common/components/bottom_bar";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import ImageIcon from '@mui/icons-material/Image';
import IconedCascateList from "../../../../../common/components/iconed_cascate_list";

/**
 * VisuallyHiddenInput
 */

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

/**
 * ObrasInformacoesGerais
 */

export const ObrasInformacoesGerais = () => {
  const viewModel = useObrasInformacoesGeraisViewModel();

  const obraEstruturaOrganizacionalColumns = useMemo(() => {
    return GenerateObraEstruturaOrganizacionalColumns({
      onActionEditar: viewModel.handleCadastroEstOrgOpenState,
      onActionDeletar: viewModel.handleDeleteEstOrgModalOpenState,
    });
  }, [
    viewModel.handleCadastroEstOrgOpenState,
    viewModel.handleDeleteEstOrgModalOpenState,
  ]);

  const atividadeObraColumns = useMemo(() => {
    return GenerateAtividadeObraColumns({
      onActionEditar: viewModel.handleCadastroAtividadeOpenState,
      onActionDeletar: viewModel.handleDeleteAtividadeModalOpenState,
    });
  }, [
    viewModel.handleCadastroAtividadeOpenState,
    viewModel.handleDeleteAtividadeModalOpenState,
  ]);

  const especificidadesObraColumns = useMemo(() => {
    return GenerateEspecificidadeObraColumns({
      onActionEditar: viewModel.handleCadastroEspecificidadeObraOpenState,
      onActionDeletar: viewModel.handleDeleteEspecificidadeObraModalOpenState,
    });
  }, [
    viewModel.handleCadastroEspecificidadeObraOpenState,
    viewModel.handleDeleteEspecificidadeObraModalOpenState,
  ]);

  const indicadoresObraColumns = useMemo(() => {
    return GenerateIndicadorObraColumns({
      onActionEditar: viewModel.handleCadastroIndicadorObraOpenState,
      onActionDeletar: viewModel.handleDeleteIndicadorObraModalOpenState,
    });
  }, [
    viewModel.handleCadastroIndicadorObraOpenState,
    viewModel.handleDeleteIndicadorObraModalOpenState,
  ]);

  const obraArquivoColumns = useMemo(() => {
    return GenerateObraArquivoColumns({
      onActionEditar: viewModel.handleCadastroObraArquivoOpenState,
      onActionDeletar: viewModel.handleDeleteObraArquivoModalOpenState,
      onActionView: viewModel.handleViewObraArquivo,
      onActionDownload: viewModel.handleDownloadObraArquivo,
    });
  }, [
    viewModel.handleCadastroObraArquivoOpenState,
    viewModel.handleDeleteObraArquivoModalOpenState,
    viewModel.handleViewObraArquivo,
    viewModel.handleDownloadObraArquivo,
  ]);

  const obraInformacoesColumns = useMemo(() => {
    return GenerateObraInformacoesColumns({
      onActionEditar: viewModel.handleCadastroObraInformacoesOpenState,
      onActionDeletar: viewModel.handleDeleteObraInformacoesModalOpenState,
    });
  }, [
    viewModel.handleCadastroObraInformacoesOpenState,
    viewModel.handleDeleteObraInformacoesModalOpenState,
  ]);

  /*
  const popperOptions = useMemo(() => {
    return [
      { id: 1, label: "Novo" },
      { id: 2, label: "Excluir" },
    ];
  }, [
  ]);
  */

  return (
    <>
      {/**
        * ObrasTopBar
        */}

      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObra}
        onBack={viewModel.handleBack}>
        {/*
          <div className="w-[7rem]">
            <PopperButton
              buttonLabel='Opções'
              options={popperOptions}
              onSelect={viewModel.handlePopperOptionSelect} />
          </div>
        */}
      </ObrasTopBar>

      <form onSubmit={viewModel.handleSubmit}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-28">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Obras
            </Link>
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to='/Obras_lista'>Lista de Obras</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro de Obras
            </Typography>
          </Breadcrumbs>

          {/**
            * ObrasTopHeader
            */}

          <ObrasTopHeader
            title='Cadastro de Obras'
            selectedObra={viewModel.selectedObra}
            onReload={viewModel.handleReload}
          />

          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReload} />
                </div>
              ) : (
                <div className="relative bg-transparent">
                  <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                    <FormContainer title={"Informações Gerais"} arrangement="fullRow" border={false}>
                      <>
                        <FormRadioGroupInput
                          name='tipo'
                          label='Status'
                          options={[
                            {
                              id: 0,
                              label: 'Em Andamento',
                              style: {
                                backgroundColor: '#f8cb00',
                                color: 'white',
                                padding: '.2rem .4rem',
                                fontSize: '0.85rem',
                                fontWeight: 700,
                                textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
                                borderRadius: '2px',
                              },
                            },
                            {
                              id: 2,
                              label: 'Paralisada',
                              style: {
                                backgroundColor: '#89c4f4',
                                color: 'white',
                                padding: '.2rem .4rem',
                                fontSize: '0.85rem',
                                fontWeight: 700,
                                textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
                                borderRadius: '2px',
                              },
                            },
                            {
                              id: 1,
                              label: 'Finalizada',
                              style: {
                                backgroundColor: '#f3565d',
                                color: 'white',
                                padding: '.2rem .4rem',
                                fontSize: '0.85rem',
                                fontWeight: 700,
                                textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
                                borderRadius: '2px',
                              },
                            },
                          ]}
                          reactHookForm={viewModel.hookForm}
                        />

                        <div className="w-full flex flex-row gap-2">
                          <div className="w-full">
                            <DefaultFormAutocomplete
                              name='idFuncionarioRevisado'
                              label='Revisado Por'
                              getOptionDisabled={x => !x.canBeSelected}
                              getOptionLabel={(x) => x.nome}
                              getOptionKey={x => x.idFuncionario}
                              options={viewModel.funcionariosRevisadoDropDown}
                              reactHookForm={viewModel.hookForm}
                            />
                          </div>

                          <div className="w-full">
                            <DefaultFormAutocomplete
                              name='idFuncionarioAprovado'
                              label='Aprovado Por'
                              getOptionDisabled={x => !x.canBeSelected}
                              getOptionLabel={(x) => x.nome}
                              getOptionKey={x => x.idFuncionario}
                              options={viewModel.funcionariosAprovadoDropDown}
                              reactHookForm={viewModel.hookForm}
                            />
                          </div>
                        </div>

                        {/* key distinta: força remontar o campo ao trocar o modo, senão o useController reaproveita o valor do outro campo. */}
                        {viewModel.hookForm.watch('porEmpreendimento') ? (
                          <DefaultFormAutocomplete
                            key='idEmpreendimento'
                            name='idEmpreendimento'
                            label='Empreendimento'
                            required={true}
                            getOptionLabel={(x) => x.title}
                            getOptionKey={(x) => x.id}
                            readOnly={viewModel.idObra !== undefined && viewModel.idObra > 0}
                            options={viewModel.empreendimentosDropdown}
                            reactHookForm={viewModel.hookForm}
                          />
                        ) : (
                          <DefaultFormAutocomplete
                            key='idCentroCusto'
                            name='idCentroCusto'
                            label='Centro de Custo'
                            required={true}
                            getOptionLabel={(x) => x.title}
                            getOptionKey={(x) => x.id}
                            readOnly={viewModel.idObra !== undefined && viewModel.idObra > 0}
                            options={viewModel.centroCustosDropdown}
                            reactHookForm={viewModel.hookForm}
                          />
                        )}


                        <DefaultFormInput
                          name='historicoRevisoes'
                          label='Histórico das Revisões'
                          multiline={true}
                          rows={10}
                          reactHookForm={viewModel.hookForm} />

                        <DefaultFormInput
                          name='apresentacaoObra'
                          label='Apresentação da Obra'
                          multiline={true}
                          rows={10}
                          reactHookForm={viewModel.hookForm} />

                        <DefaultFormInput
                          name='processo'
                          label='Processos do sistema de gestão da qualidade aplicáveis à obra'
                          multiline={true}
                          rows={10}
                          reactHookForm={viewModel.hookForm} />

                      </>
                    </FormContainer>
                  </div>

                  {/**
                    * Estrutura Organizacional
                    */}

                  {isValidId(viewModel.idObra) &&
                    <>
                      <ActionBanner
                        icon={<FolderOpen style={{ fontSize: 24 }} />}
                        title="Estrutura Organizacional"
                        description="Gerencie a estrutura organizacional."
                        buttonIcon={<Launch style={{ fontSize: 18 }} />}
                        buttonText="Abrir Estrutura Organizacional"
                        onClick={() => viewModel.handleEstOrgListaOpenState(true)}
                      />

                      <div className="w-full h-4" />
                    </>
                  }

                  {/**
                    * Atividades
                    */}

                  {isValidId(viewModel.idObra) &&
                    <>
                      <ActionBanner
                        icon={<FolderOpen style={{ fontSize: 24 }} />}
                        title="Atividades"
                        description="Gerencie as atividades."
                        buttonIcon={<Launch style={{ fontSize: 18 }} />}
                        buttonText="Abrir Atividades"
                        onClick={() => viewModel.handleAtividadeListaModalOpenState(true)}
                      />

                      <div className="w-full h-4" />
                    </>
                  }

                  {/**
                    * Particularidades da obra
                    */}

                  {isValidId(viewModel.idObra) &&
                    <>
                      <ActionBanner
                        icon={<FolderOpen style={{ fontSize: 24 }} />}
                        title="Particularidades da obra"
                        description="Gerencie as particularidades da obra."
                        buttonIcon={<Launch style={{ fontSize: 18 }} />}
                        buttonText="Abrir Particularidades da obra"
                        onClick={() => viewModel.handleEspecificidadeListaObraModalOpenState(true)}
                      />

                      <div className="w-full h-4" />
                    </>
                  }

                  {/**
                    * PCT, PDE, FAD e DATec
                    */}

                  <div>
                    <IconedCascateList
                      title="PCT, PDE, FAD e DATec"
                      icon={<FolderOpen style={{ fontSize: 24 }} />}>
                      <>
                        <DefaultFormInput
                          name='pctPdeFadDatec'
                          label='PCT, PDE, FAD e DATec'
                          multiline={true}
                          rows={10}
                          reactHookForm={viewModel.hookForm}
                        />
                      </>
                    </IconedCascateList>

                    <div
                      className="w-full h-4"
                    />
                  </div>

                  {/**
                    * Objetivos Específicos da Obra
                    */}

                  {isValidId(viewModel.idObra) &&
                    <>
                      <ActionBanner
                        icon={<FolderOpen style={{ fontSize: 24 }} />}
                        title="Objetivos Específicos da Obra"
                        description="Gerencie os objetivos Específicos da obra."
                        buttonIcon={<Launch style={{ fontSize: 18 }} />}
                        buttonText="Abrir Objetivos Específicos da Obra"
                        onClick={() => viewModel.handleIndicadorObraListaModalOpenState(true)}
                      />

                      <div className="w-full h-4" />
                    </>
                  }

                  {/**
                    * Meios para assegurar um ambiente de trabalho saudável e seguro
                    */}

                  <div>
                    <IconedCascateList
                      title="Meios para assegurar um ambiente de trabalho saudável e seguro"
                      icon={<FolderOpen style={{ fontSize: 24 }} />}>
                      <>
                        <DefaultFormInput
                          name='meios'
                          label='Meios para assegurar um ambiente de trabalho saudável e seguro'
                          multiline={true}
                          rows={10}
                          reactHookForm={viewModel.hookForm} />
                      </>
                    </IconedCascateList>

                    <div className="w-full h-4" />
                  </div>

                  {/**
                    * Anexar Documento
                    */}

                  {isValidId(viewModel.idObra) &&
                    <>
                      <ActionBanner
                        icon={<FolderOpen style={{ fontSize: 24 }} />}
                        title="Documentos"
                        description="Gerencie os documentos da obra."
                        buttonIcon={<Launch style={{ fontSize: 18 }} />}
                        buttonText="Abrir Documentos"
                        onClick={() => viewModel.handleObraArquivoListaModalOpenState(true)}
                      />

                      <div className="w-full h-4" />
                    </>
                  }

                  {/**
                    * Informações da Obra
                    */}

                  {isValidId(viewModel.idObra) &&
                    <>
                      <ActionBanner
                        icon={<FolderOpen style={{ fontSize: 24 }} />}
                        title="Informações da Obra"
                        description="Gerencie as informações da obra."
                        buttonIcon={<Launch style={{ fontSize: 18 }} />}
                        buttonText="Abrir Informações da Obra"
                        onClick={() => viewModel.handleObraInformacoesListaOpenState(true)}
                      />

                      <div className="w-full h-4" />
                    </>
                  }

                  {/**
                    * Imagem - Estrutura Organizacional
                    */}

                  <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode">
                    <p className="text-back dark:text-white">Imagem - Estrutura Organizacional</p>
                    <div className="w-full min-h-[20rem] flex flex-col justify-center items-center my-4">
                      {
                        viewModel.estOrgFileUploadUrl ? (
                          <img
                            src={viewModel.estOrgFileUploadUrl}
                            className="w-full h-full object-contain bg-center bg-no-repeat"
                            alt="Estrutura Organizacional" />
                        ) : (
                          viewModel.selectedObra && viewModel.selectedObra.imgEo ? (
                            <img
                              src={`data:image/*; base64,${viewModel.selectedObra.imgEo}`}
                              className="w-full h-full object-contain bg-center bg-no-repeat"
                              alt="Estrutura Organizacional" />
                          ) : (
                            <span className="text-orange-400 flex flex-col justify-center items-center">
                              <ImageIcon sx={{ width: 50, height: 50 }} />
                              <p className="text-xs text-black dark:text-white">Não ha imagem a ser exibida!</p>
                            </span>
                          )
                        )
                      }
                    </div>
                    <div className="flex flex-row justify-between items-center">
                      <div>
                        <p className="text-back dark:text-white flex flex-row items-center justify-center gap-2">
                          <span className="text-sm text-bold bg-[#f3565d] px-2">Atenção</span>
                          <span className="text-sm">São permitidas apenas imagens com extensão .png, .jpeg, .jpg, .gif, .img!</span>
                        </p>
                      </div>
                      <div className="flex flex-row w-[20rem] gap-4 justify-end">
                        <div>
                          <PrimaryButton
                            component="label">
                            <VisuallyHiddenInput
                              type="file"
                              id='estOrgImageInput'
                              onChange={(e) => { viewModel.handleStartEstOrgFileUpload(e.target.files?.item(0) ?? null) }}
                              accept=".png,.jpeg,.jpg,.gif,.img"
                              multiple={false} />
                            Selecione a imagem
                          </PrimaryButton>
                        </div>
                        <div className="w-[8rem]">
                          <PrimaryButton
                            buttonColor="red"
                            onClick={viewModel.handleDeleteEstOrgFileUpload}>
                            Excluir
                          </PrimaryButton>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/**
                    * Imagem - Canteiro de Obra
                    */}

                  <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mt-4">
                    <p className="text-back dark:text-white">Imagem - Canteiro de Obra</p>
                    <div className="w-full min-h-[20rem] flex flex-col justify-center items-center my-4">
                      {
                        viewModel.cantFileUploadUrl ? (
                          <img
                            src={viewModel.cantFileUploadUrl}
                            className="w-full h-full object-contain bg-center bg-no-repeat"
                            alt="Canteiro de Obra" />
                        ) : (
                          viewModel.selectedObra && viewModel.selectedObra.imgCo ? (
                            <img
                              src={`data:image/*; base64,${viewModel.selectedObra.imgCo}`}
                              className="w-full h-full object-contain bg-center bg-no-repeat"
                              alt="Canteiro de Obra" />
                          ) : (
                            <span className="text-orange-400 flex flex-col justify-center items-center">
                              <ImageIcon sx={{ width: 50, height: 50 }} />
                              <p className="text-xs text-black dark:text-white">Não ha imagem a ser exibida!</p>
                            </span>
                          )
                        )
                      }
                    </div>
                    <div className="flex flex-row justify-between items-center">
                      <div>
                        <p className="text-back dark:text-white flex flex-row items-center justify-center gap-2">
                          <span className="text-sm text-bold bg-[#f3565d] px-2">Atenção</span>
                          <span className="text-sm">São permitidas apenas imagens com extensão .png, .jpeg, .jpg, .gif, .img!</span>
                        </p>
                      </div>
                      <div className="flex flex-row w-[20rem] gap-4 justify-end">
                        <div>
                          <PrimaryButton
                            component="label">
                            <VisuallyHiddenInput
                              type="file"
                              id='cantImageInput'
                              onChange={(e) => { viewModel.handleStartCantFileUpload(e.target.files?.item(0) ?? null) }}
                              accept=".png,.jpeg,.jpg,.gif,.img"
                              multiple={false} />
                            Selecione a imagem
                          </PrimaryButton>
                        </div>
                        <div className="w-[8rem]">
                          <PrimaryButton
                            buttonColor="red"
                            onClick={viewModel.handleDeleteCantFileUpload}>
                            Excluir
                          </PrimaryButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
          }
        </div>

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {
                isValidId(viewModel.idObra) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      {/**
        * Obra delete modal.
        */}

      <DeleteDialog
        open={viewModel.obraDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteObraModalOpenState(true)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmObra} />

      {/**
        * Estrutura Organizacional Modal
        */}

      <EstOrgListaModal
        open={viewModel.estOrgListaModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        columns={obraEstruturaOrganizacionalColumns}
        items={viewModel.estOrgLista}
        pagination={viewModel.pagination.estOrg}
        onClose={() => viewModel.handleEstOrgListaOpenState(false)}
        onPageChange={viewModel.handleEstOrgPageChange}
        onRowsPerPageChange={viewModel.handleEstOrgRowsPerPageChange}
        onNovoItem={() => viewModel.handleCadastroEstOrgOpenState(null, true)}
      />

      <EstOrgModal
        open={viewModel.estOrgModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedEstOrg={viewModel.selectedEstOrg ?? null}
        funcionariosDropdown={viewModel.estOrgfuncionariosDropdown}
        onClose={() => viewModel.handleCadastroEstOrgOpenState(null, false)}
        onSubmit={viewModel.handleEstOrgSubmit} />

      <DeleteDialog
        open={viewModel.estOrgDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteEstOrgModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmEstOrg} />

      {/**
        * Estrutura Organizacional Modal
        */}

      <AtividadeObraListaModal
        open={viewModel.atividadeListaObraModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        columns={atividadeObraColumns}
        items={viewModel.atividadeObraLista}
        pagination={viewModel.pagination.atividadesObra}
        onClose={() => viewModel.handleAtividadeListaModalOpenState(false)}
        onNewItem={() => viewModel.handleCadastroAtividadeOpenState(null, true)}
        onPageChange={viewModel.handleAtividadesPageChange}
        onRowsPerPageChange={viewModel.handleAtividadesRowsPerPageChange}
      />

      <AtividadeObraModal
        open={viewModel.atividadeObraModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedAtividadeObra={viewModel.selectedAtividadeObra ?? null}
        responsavelDropdown={viewModel.responsavelDropdown}
        corresponsavelDropdown={viewModel.corresponsavelDropdown}
        onClose={() => viewModel.handleCadastroAtividadeOpenState(null, false)}
        onSubmit={viewModel.handleAtividadeSubmit} />

      <DeleteDialog
        open={viewModel.atividadeObraDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteAtividadeModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmAtividade} />

      {/**
        * Especificidade Obra Modal
        */}

      <EspecificidadeObraListaModal
        open={viewModel.especificidadeListaObraModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        columns={especificidadesObraColumns}
        items={viewModel.especificidadeObraLista}
        pagination={viewModel.pagination.especificidadesObra}
        onClose={() => viewModel.handleEspecificidadeListaObraModalOpenState(false)}
        onNewItem={() => viewModel.handleCadastroEspecificidadeObraOpenState(null, true)}
        onPageChange={viewModel.handleEspecificidadesObraPageChange}
        onRowsPerPageChange={viewModel.handleEspecificidadesObraRowsPerPageChange}
      />

      <EspecificidadeObraModal
        open={viewModel.especificidadeObraModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedEspecificidadeObra={viewModel.selectedEspecificidadeObra ?? null}
        onClose={() => viewModel.handleCadastroEspecificidadeObraOpenState(null, false)}
        onSubmit={viewModel.handleEspecificidadeObraSubmit} />

      <DeleteDialog
        open={viewModel.especificidadeObraDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteEspecificidadeObraModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmEspecificidadeObra} />

      {/**
        * Indicador Obra Modal
        */}

      <IndicadorObraListaModal
        open={viewModel.indicadorObraListaModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        columns={indicadoresObraColumns}
        items={viewModel.indicadorObraLista}
        pagination={viewModel.pagination.indicadoresObra}
        onClose={() => viewModel.handleIndicadorObraListaModalOpenState(false)}
        onNewItem={() => viewModel.handleCadastroIndicadorObraOpenState(null, true)}
        onPageChange={viewModel.handleIndicadorObraPageChange}
        onRowsPerPageChange={viewModel.handleIndicadorObraRowsPerPageChange}
      />

      <IndicadorObraModal
        open={viewModel.indicadorObraModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        indicadores={viewModel.indicadoresDropdown}
        selectedIndicadorObra={viewModel.selectedIndicadorObra}
        onClose={() => viewModel.handleCadastroIndicadorObraOpenState(null, false)}
        onSubmit={viewModel.handleIndicadorObraSubmit} />

      <DeleteDialog
        open={viewModel.indicadorObraDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteIndicadorObraModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmIndicadorObra} />

      {/**
        * Arquivo Modal
        */}

      <ObraArquivoListaModal
        open={viewModel.obraArquivoListaModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        columns={obraArquivoColumns}
        items={viewModel.obraArquivoLista}
        pagination={viewModel.pagination.obraArquivos}
        onClose={() => viewModel.handleObraArquivoListaModalOpenState(false)}
        onNewItem={() => viewModel.handleCadastroObraArquivoOpenState(null, true)}
        onPageChange={viewModel.handleObraArquivoPageChange}
        onRowsPerPageChange={viewModel.handleObraArquivoRowsPerPageChange}
      />

      <ObraArquivoModal
        open={viewModel.obraArquivoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedObraArquivo={viewModel.selectedObraArquivo ?? null}
        reactHookForm={viewModel.hookFormObraArquivo}
        onClose={() => viewModel.handleCadastroObraArquivoOpenState(null, false)}
        onSubmit={viewModel.handleObraArquivoSubmit}
        onDownload={viewModel.handleDownloadObraArquivo} />

      <DeleteDialog
        open={viewModel.obraArquivoDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteObraArquivoModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmObraArquivo} />

      {/**
        * Obra Informacoes Modal
        */}

      <ObraInformacoesListaModal
        open={viewModel.obraInformacoesListaModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        data={viewModel.filters.data}
        informacoes={viewModel.filters.informacoes}
        columns={obraInformacoesColumns}
        items={viewModel.obraInformacoesLista}
        pagination={viewModel.pagination.obraInformacoes}
        onClose={() => viewModel.handleObraInformacoesListaOpenState(false)}
        onNewItem={() => viewModel.handleCadastroObraInformacoesOpenState(null, true)}
        onDataChange={viewModel.handleFiltersDataChange}
        onInformacoesChange={viewModel.handleFiltersInformacoesChange}
        onClearFilters={viewModel.handleObraInformacoesClearFilters}
        onPageChange={viewModel.handleObraInformacoesPageChange}
        onRowsPerPageChange={viewModel.handleObraInformacoesRowsPerPageChange}
      />

      <ObraInformacoesModal
        open={viewModel.obraInformacoesModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        funcionariosInfObraDropdown={viewModel.funcionariosInfObraDropDown}
        selectedObraInformacoes={viewModel.selectedObraInformacoes ?? null}
        onClose={() => viewModel.handleCadastroObraInformacoesOpenState(null, false)}
        onSubmit={viewModel.handleObraInformacoesSubmit} />

      <DeleteDialog
        open={viewModel.obraInformacoesDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteObraInformacoesModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmObraInformacoes} />

      {/**
        * Obra Informacoes Modal
        */}

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      {/**
        * Modal historico de alterações.
        */}

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

    </>
  );
}